import React from 'react';
import { Outlet, useLocation } from 'react-router';
import Footer from 'Components/Footer';
import Header from 'Components/Header';

function AuthenticatedWrapper() {
  const location = useLocation();

  return (
    <div className="main-layout">
      <Header location={location} />
      <Outlet />
      <Footer />
    </div>
  );
}

export default AuthenticatedWrapper;
